export const LANDING = '/';
export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';
export const ACCOUNT = '/account';
export const ADMIN = '/admin';
export const CUSTOMER_VIEW = '/customer-view/:freight_forwarder_id/quotes/:quote_id';
export const CUSTOMER_VIEW_CONDITIONS = '/customer-view/:freight_forwarder_id/quotes/:quote_id/conditions_of_trade';

export const CUSTOMER_VIEW_RATE_SHEET = '/customer-view/:freight_forwarder_id/ratesheets/:ratesheet_id';

export const FREIGHT_FORWARDERS = '/freight-forwarders';
export const FREIGHT_FORWARDER = `${FREIGHT_FORWARDERS}/:freight_forwarder_id`;

export const CLIENTS = `${FREIGHT_FORWARDER}/clients`;
export const CLIENTS_NEW = `${CLIENTS}/new`;
export const CLIENT = `${CLIENTS}/:client_id`;

export const SERVICE_PROVIDERS = `${FREIGHT_FORWARDER}/service-providers`;
export const SERVICE_PROVIDERS_NEW = `${SERVICE_PROVIDERS}/new`;
export const SERVICE_PROVIDER = `${SERVICE_PROVIDERS}/:service_provider_id`;

export const AGENTS = `${FREIGHT_FORWARDER}/agents`;
export const AGENTS_NEW = `${AGENTS}/new`;
export const AGENT = `${AGENTS}/:agent_id`;

export const PORT_PAIRS_INDEX = `${FREIGHT_FORWARDER}/port-pairs`;
export const PORT_PAIR_NEW = `${PORT_PAIRS_INDEX}/new`;
export const PORT_PAIR = `${PORT_PAIRS_INDEX}/:service_id`;

export const CHARGES = `${FREIGHT_FORWARDER}/charges`;
export const CHARGES_NEW = `${CHARGES}/new`;
export const CHARGE = `${CHARGES}/:charge_id`;

export const QUOTES = `${FREIGHT_FORWARDER}/quotes`;
export const QUOTE = `${QUOTES}/:quote_id`;
export const QUOTES_NEW = `${QUOTES}/new`;
export const QUOTES_NEW_NO_SERVICE = `${QUOTES}/new-no-service`;

export const CURRENCIES = `${FREIGHT_FORWARDER}/currencies`;
export const CURRENCY = `${CURRENCIES}/:currency_id`;
export const CURRENCIES_NEW = `${CURRENCIES}/new`;

export const FF_USERS = `${FREIGHT_FORWARDER}/users`;
export const FF_USER = `${FF_USERS}/:user_id`;
export const FF_USERS_NEW = `${FF_USERS}/new`;

export const BULK_UPDATES = `${FREIGHT_FORWARDER}/bulk-updates`;

export const RATE_SHEETS = `${FREIGHT_FORWARDER}/ratesheets`;
export const RATE_SHEET = `${RATE_SHEETS}/:ratesheet_id`;

// Admin routes
export const USERS = `${ADMIN}/users`;
export const USER = `${USERS}/:user_id`;
export const USERS_NEW = `${USERS}/new`;

export const FREIGHT_FORWARDERS_ADMIN = `${ADMIN}/freight-forwarders`;
export const FREIGHT_FORWARDER_EDIT = `${FREIGHT_FORWARDERS_ADMIN}/:freight_forwarder_id`;
export const FREIGHT_FORWARDERS_NEW = `${FREIGHT_FORWARDERS_ADMIN}/new`;

export const PASSWORD_FORGET = '/pw-forget';
